import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalBody} from "reactstrap"
import {changeProductionStatus} from "../../services/api/apiNextBarcode"
import {pushNewItemHistory} from "../../services/api/apiItemHistory"


class ModalEditStatus extends Component {
    state = {
        status: this.props.status === 'packaged' ? 'cancelled' : this.props.status,
        loading: false,
    }

    _handleChange = e => {
        const {value} = e.target

        this.setState({
            status: value
        })
    }

    _handleClickChange = e => {
        e.preventDefault()

        return this._change()
    }

    _change = async () => {
        if (this.state.loading) return false

        this.setState({loading: true})

        const {status} = this.state
        try {
            const {_id, production_status} = this.props.item

            const response = await changeProductionStatus(_id, status)

            const {success, message} = response

            if (!success) {
                return this.setState({
                    loading: false
                }, () => {
                    window.alert(message)
                })
            }

            this.setState({
                loading: false
            }, () => {
                this.props.onClose()
                return pushNewItemHistory(`${this.props.item.barcodeNumber}_1`, {
                    event_key: 'change_status',
                    event_description: `Change status on single action`,
                    event_meta: {
                        from: production_status,
                        to: status
                    }
                })
            })
        } catch (e) {
            this.setState({
                loading: false
            }, () => {
                window.alert(e.message)
            })
        }
    }

    render() {
        const {isOpen, onClose} = this.props
        const {status, loading} = this.state


        return (
            <div className="ModalEditStatus">
                <Modal isOpen={isOpen} toggle={onClose}>
                    <ModalBody>
                        <select className="form-control" value={status} onChange={this._handleChange}>
                            <option value="review">Review</option>
                            <option value="repaired">Repaired</option>
                            <option value="exported">Exported</option>
                            <option value="on-hold">On Hold</option>
                            <option value="cancelled">Cancelled</option>
                        </select>
                        <button disabled={loading} onClick={this._handleClickChange} className="btn btn-primary mt-2">
                            Change status
                        </button>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

ModalEditStatus.propTypes = {
    onClose: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
}

export default ModalEditStatus
